import { useCallback } from 'react';
import { useUpdateMillerColumns } from 'src/features/millerColumns/hooks/useUpdateMillerColumns';

export const useRenameItemButtonColumnView = () => {
  const refreshColumns = useUpdateMillerColumns();

  return useCallback(() => refreshColumns(), [refreshColumns]);
};
